export default function styles(theme) {
  return {
    title: {
      display: "block",
      width: "100%",
      textAlign: "center",
      ...theme.palette.text.gradient
    },
    secondaryTitle: {
      fontSize: "2rem",
      fontFamily: "EudoxusSans",
      fontWeight: 600,
      textAlign: "left",
      width: "100%",
      letterSpacing: "1px",
      color: theme.palette.text.primary,
      margin: "0rem",
      padding: "0rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem",
      },
    },
    subTitle: {
      color: theme.palette.text.tertiary,
    },
    link: {
      color: theme.palette.text.primary,
      fontWeight: "300",
      textDecoration: "none",
      padding: "8px 0px",
      display: "inline-block",
      position: "relative",
      borderBottom: "0.5px solid #434f66",
      lineHeight: "20px",
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'fit-content',
      "&::after": {
        content: '""',
        position: "absolute",
        width: "100%",
        transform: "scaleX(0)",
        height: "0.5px",
        bottom: "-1px",
        left: "0px",
        zIndex: "2",
        backgroundColor: theme.palette.text.primary,
        transformOrigin: "bottom right",
        transition: "transform 0.4s cubic-bezier(0.86, 0, 0.07, 1)",
      },
      "&:hover::after": {
        transform: "scaleX(1)",
        transformOrigin: "bottom left",
      }
    },
    description: {
      margin: "auto",
      display: "block",
      textAlign: "left",
      fontSize: "1rem",
      fontWeight: 100,
      padding: "1rem 0rem",
      color: theme.palette.text.tertiary
    },
    testimonial: {
      border: '1px solid rgba(121, 131, 150, 0.15)',
      backgroundColor: theme.palette.primary.main,
      borderRadius: '20px',
      padding: "3rem 3rem",
      alignContent: "center",
      display: "Grid",
      gridTemplateColumns: "1fr 3fr",
      alignItems: "center",
      gridGap: "2rem",
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
        padding: '2rem 1rem',
      },
    },
    imageContainer: {
      width: "100%"
    },
    img: {
      width: "100%",
      border: '1px solid rgba(121, 131, 150, 0.5)',
      borderRadius: "50%",
      padding: "0.8rem",
      margin: "auto",
      [theme.breakpoints.down("sm")]: {
        width: "50%",
        padding: "0.5rem",
      },
    }
  };
}
